import { useMemo } from 'react';

import type { Datum, Fill } from '../../types';

import type { PieArcDatum } from 'd3-shape';
import type { ProvidedProps } from '@visx/shape/lib/shapes/Pie';

import { StyledAnimatedPath } from './styled';

import { INNER_RADIUS, OUTER_RADIUS } from '../../constants';

interface Props {
  arc: PieArcDatum<Datum>;
  pie: ProvidedProps<Datum>;
  fill: Fill;
  selected: number;
  onSelect: (index: number) => void;
}

export const Arc = ({ pie, arc, fill, selected, onSelect }: Props) => {
  const { index } = arc;

  const outerArc = useMemo(() => {
    pie.path.innerRadius(OUTER_RADIUS + 2);
    pie.path.outerRadius(OUTER_RADIUS + 8);
    return pie.path(arc);
  }, [pie, arc]);

  const innerArc = useMemo(() => {
    pie.path.innerRadius(INNER_RADIUS);
    pie.path.outerRadius(OUTER_RADIUS);
    return pie.path(arc);
  }, [pie, arc]);

  if (innerArc === null) return null;

  return (
    <>
      <path
        d={innerArc}
        fill={fill}
        onMouseOver={() => onSelect(index)}
        onTouchStart={() => onSelect(index)}
        data-cy-id={`segment-${index}`}
      />
      {outerArc && selected === index && (
        <StyledAnimatedPath
          data-cy-id={`segment-${index}-hover`}
          d={outerArc}
          fill={fill}
        />
      )}
    </>
  );
};
